import I18n from 'I18n';
import { useCallback, useState } from 'react';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { H5 } from 'foundations-components/transitional/components/H5';
import FeedbackOptionButtons from './FeedbackOptionButtons';
import { isFunction } from './typeUtils';
import { Button } from 'foundations-components/transitional/components/Button';
import { Flex } from 'foundations-components/components/Flex';
import { Popover } from 'foundations-components/transitional/components/Popover';
import { Text } from 'foundations-components/components/Text';
import { TextArea } from 'foundations-components/transitional/components/TextArea';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const InlineFeedbackPopover = ({
  children,
  feedbackPopoverWidth = '325px',
  popoverOpen,
  onSubmit,
  onCancel,
  feedbackOptions,
  freeformPlaceholder,
  headerI18nKey
}) => {
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [messageFeedback, setMessageFeedback] = useState('');
  const handleMessageFeedbackChange = useCallback(({
    target: {
      value
    }
  }) => {
    setMessageFeedback(value);
  }, []);
  const handleMessageFeedbackOptionsChange = useCallback(option => {
    if (selectedOptions.includes(option)) {
      setSelectedOptions(selectedOptions.filter(e => e !== option));
    } else {
      setSelectedOptions([...selectedOptions, option]);
    }
  }, [selectedOptions]);
  const handleSubmit = useCallback(() => {
    if (isFunction(onSubmit)) {
      onSubmit({
        options: selectedOptions,
        message: messageFeedback
      });
    }
  }, [onSubmit, messageFeedback, selectedOptions]);
  const canSubmit = selectedOptions.length > 0 || messageFeedback.length > 0;
  return /*#__PURE__*/_jsx(Popover, {
    "data-test-id": "inline-feedback-popover",
    maxInlineSize: feedbackPopoverWidth,
    open: popoverOpen,
    content: {
      header: /*#__PURE__*/_jsx(H5, {
        children: /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: headerI18nKey
        })
      }),
      body: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(Text, {
          typography: "body-100",
          marginBlockEnd: "200",
          children: /*#__PURE__*/_jsx(FormattedReactMessage, {
            message: "dealSummary.feedback.form.optionSelectionHeader"
          })
        }), feedbackOptions && /*#__PURE__*/_jsx(FeedbackOptionButtons, {
          feedbackOptions: feedbackOptions,
          selectedOptions: selectedOptions,
          onOptionSelect: handleMessageFeedbackOptionsChange
        }), /*#__PURE__*/_jsx(TextArea, {
          "data-test-id": "feedback-freeform",
          placeholder: I18n.text(freeformPlaceholder),
          onBlur: handleMessageFeedbackChange
        })]
      }),
      footer: /*#__PURE__*/_jsxs(Flex, {
        flexDirection: "row",
        justifyContent: "end",
        children: [/*#__PURE__*/_jsx(Button, {
          onClick: onCancel,
          type: "reset",
          use: "secondary",
          size: "sm",
          width: "fit-content",
          margin: "0",
          marginInlineEnd: "300",
          children: /*#__PURE__*/_jsx(FormattedReactMessage, {
            message: "dealSummary.cancel"
          })
        }), /*#__PURE__*/_jsx(Button, {
          "data-test-id": "inline-feedback-popover-submit",
          onClick: handleSubmit,
          type: "submit",
          use: "primary",
          size: "sm",
          width: "fit-content",
          margin: "0",
          disabled: !canSubmit,
          children: /*#__PURE__*/_jsx(FormattedReactMessage, {
            message: "dealSummary.submit"
          })
        })]
      })
    },
    children: /*#__PURE__*/_jsx(_Fragment, {
      children: children
    })
  });
};
export default InlineFeedbackPopover;